/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import FileSystemType from '../file/system/file-system-type';

/**
 * Vyhledávač interní jednotky.
 * @implements {FileSystemUnitFinder}
 */
class FileSystemUnitFinderInternalPriority {
  /**
   * Vrátí první nalezenou interní jednotku.
   * @param {FileSystemUnit[]} fileSystemUnits pole fyzických jednotek.
   * @returns {Promise<FileSystemUnit|null>} nalezená fyzická jednotka.
   */
  find(fileSystemUnits) {
    return new Promise((resolve) =>
      resolve(
        fileSystemUnits.find((u) => u.getType() === FileSystemType.Internal) ||
          null
      )
    );
  }
}

export default FileSystemUnitFinderInternalPriority;
